const { getElement } = window.BAO.Utils;

class CustomerForm extends window.BAO.CustomElement() {
	connectedCallback() {
		super.connectedCallback();

		this.currentVisibleForm = 'login';
	}

	setupListeners () {
		super.setupListeners()

		this.toggleFormVisibility = this.toggleFormVisibility.bind(this);
		this.setFormSubmitToken = this.setFormSubmitToken.bind(this);

		console.log('button', this.buttons)

		this.listeners.add(this.buttons.reset.element, 'click', () =>
			this.toggleFormVisibility('reset'),
		);

		this.buttons.cancel.elements.forEach((cancelEl) => {
			this.listeners.add(cancelEl, 'click', () =>
				this.toggleFormVisibility('login'),
			);
		});

		this.listeners.add(this.buttons.register.element, 'click', () =>
			this.toggleFormVisibility('register'),
		);

		// Set sessionStorage to retrieve form on error
		['login', 'reset', 'register'].forEach((type) => {
			this.listeners.add(this.formElements[type], 'submit', () =>
				this.setFormSubmitToken(type),
			);
		});

		// Load form based on session storage value
		this.listeners.add(document, 'DOMContentLoaded', () => {
			const formType = this.getFormSubmitToken();
			if (formType) this.toggleFormVisibility(formType);
		});
	}

	/**
	 * Toggles visibility of the specified form, hiding others.
	 * @param {string} formType - The type of form to display ('login', 'reset', or 'register').
	 */
	toggleFormVisibility(formType) {
		this.currentVisibleForm = formType;

		Object.entries(this.forms).forEach(([key, form]) => {
			const isVisible = key === formType;
			form.element.ariaHidden = !isVisible;

			if (this.formElements[key] && !isVisible) {
				this.formElements[key].reset();
			}

			switch (key) {
				case 'login':
					this.intros.login.ariaHidden = !isVisible
					break;
				case 'register':
					this.intros.register.ariaHidden = !isVisible
					break;
				default:
					break;
			}

			if (this.intros[key] && !isVisible) {
				this.intros[key].ariaHidden = !isVisible;
			}
		});
	}

	getFormSubmitToken() {
		return window.sessionStorage.getItem('LockedFormType') || null;
	}

	setFormSubmitToken(form) {
		window.sessionStorage.setItem('LockedFormType', form);
	}

	get forms () {
		return {
			login: this.els?.formLogin,
			reset: this.els?.formReset,
			register: this.els?.formRegister,
		};
	}

	get intros () {
		return {
			login: this.externalEls?.loginIntro.element,
			register: this.externalEls?.registerIntro.element,
		}
	}

	get buttons () {
		return {
			reset: this.els?.resetButton,
			cancel: this.els?.cancelReset,
			register: this.externalEls?.registerButton,
		}
	}

	get formElements () {
		return Object.fromEntries(
			Object.entries(this.forms).map(([key, form]) => [
				key,
				getElement('form', { context: form.element }),
			]),
		);
	}

	get currentVisibleForm () {
		return this._currentVisibleForm
	}

	set currentVisibleForm (form) {
		this._currentVisibleForm = form
	}
}

if (!customElements.get('customer-form')) {
	customElements.define('customer-form', CustomerForm);
}
